import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-esignature-tooltip',
  templateUrl: './e-signature-tooltip.component.html',
  styleUrl: './e-signature-tooltip.component.scss',
  standalone: false,
})
export class ESignatureTooltipComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();
  
  @Input()
  eSignatureImageUrl!: string;
  
  @ViewChild('iconRef', { read: ElementRef }) iconRef!: ElementRef<HTMLElement>;  

  show() {
    this.showModal = true;
    this.showModalChange.emit(this.showModal);
  }

  close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
